export const services = [
  {
    title: "Projektledelse",
    description: "Portefølje-, program- og projektafvikling med fokus på tid, økonomi, risiko og fremdrift.",
    icon: "Briefcase"
  },
  {
    title: "Teknisk projektledelse",
    description: "Koordinering mellem discipliner, leverandører og site; change control, interface- og kravstyring.",
    icon: "Settings2"
  },
  {
    title: "Engineering",
    description: "LV‑el, UPS, tavler, E‑house, belysning, selektivitet, kortslutningsberegninger, specifikationer og udbud.",
    icon: "Zap"
  },
  {
    title: "Review & kontrol",
    description: "Teknisk review og QA af dokumentation, nummerering, revisionsstyring, metadata og overleveringspakker.",
    icon: "ClipboardCheck"
  },
  {
    title: "HSEQ",
    description: "Praktiske procedurer, risikovurderinger, audits, toolbox‑talks, KPI'er og løbende forbedringer.",
    icon: "ShieldAlert"
  },
  {
    title: "Arbejdsmiljøkoordinator",
    description: "PSS, koordination P og B, entreprenørmøder og myndighedsdialog.",
    icon: "Users"
  }
];

export const references = [
  {
    slug: "semco-maritime-offshore",
    company: "Semco Maritime",
    title: "Offshore transformerstation",
    description: "Design og engineering af LV-installationer, UPS-anlæg, tavler og belysning til offshore miljø.",
    fullDescription: "Green Energy Consulting bistod Semco Maritime med omfattende engineering-ydelser til en offshore transformerstation. Projektet krævede høj teknisk præcision og overholdelse af strenge offshore-standarder.",
    keyResults: [
      "Komplet LV-design og dimensionering",
      "Projektering af UPS-backup systemer",
      "Udarbejdelse af tavlespecifikationer",
      "Belysningsberegninger og layout"
    ],
    technologies: ["LV Engineering", "UPS Systems", "Offshore Standards", "Technical Review"],
    image: "/ref-semco.png"
  },
  {
    slug: "enabl-teknisk-projektledelse",
    company: "ENABL",
    title: "Teknisk projektledelse",
    description: "Koordinering mellem tekniske discipliner og sikring af fremdrift i komplekse maskinanlæg.",
    fullDescription: "Hos ENABL varetog vi rollen som teknisk projektleder med fokus på at bygge bro mellem de forskellige ingeniørdiscipliner. Opgaven indebar tæt styring af interfaces og sikring af, at tekniske løsninger mødte kundens krav.",
    keyResults: [
      "Effektiv interface-styring",
      "Disciplinkoordinering",
      "Kvalitetssikring af teknisk dokumentation",
      "Optimering af arbejdsgange"
    ],
    technologies: ["Project Management", "Interface Management", "QA/QC", "Technical Coordination"],
    image: "/ref-enabl.png"
  },
  {
    slug: "abb-paen-ptx",
    company: "ABB PAEN",
    title: "PtX-projekter",
    description: "Engineering og dokumentationsreview for E-house, UPS og LV i banebrydende PtX-anlæg.",
    fullDescription: "Vi støttede ABB PAEN i udviklingen af Power-to-X løsninger. Fokus lå på integration af E-houses og sikring af robust el-infrastruktur gennem detaljeret engineering og review.",
    keyResults: [
      "E-house integration og review",
      "LV og UPS dimensionering",
      "Commissioning support",
      "Metadata og dokumentationsstyring"
    ],
    technologies: ["PtX", "E-House", "LV/MV Systems", "Commissioning"],
    image: "/ref-abb.png"
  },
  {
    slug: "din-forsyning-varmepumpe",
    company: "Din Forsyning",
    title: "Havvandskølet varmepumpe",
    description: "Projektstøtte til etablering af storskala varmepumpeanlæg til bæredygtig fjernvarme.",
    fullDescription: "I samarbejde med Din Forsyning arbejdede vi på et af Danmarks største varmepumpeprojekter, der udnytter energi fra havvandet til at levere CO2-neutral fjernvarme.",
    keyResults: [
      "El-teknisk review",
      "HSEQ koordinering",
      "Tilsyn med el-entrepriser",
      "Dokumentationskontrol"
    ],
    technologies: ["District Heating", "Heat Pumps", "Sustainability", "HSEQ"],
    image: "/ref-varmepumpe.png"
  },
  {
    slug: "sweco-pharma-engineering",
    company: "Sweco",
    title: "Pharma-engineering",
    description: "Specialiseret el-projektering til pharma-industrien med fokus på forsyningssikkerhed og GMP.",
    fullDescription: "Vi leverede el-teknisk ekspertise til Sweco i forbindelse med pharma-projekter. Her var fokus på høj driftssikkerhed, redundans og overholdelse af GMP-krav.",
    keyResults: [
      "Pharma-grade el-design",
      "Selektivitetsberegninger",
      "GMP dokumentation",
      "Kravspecifikationer"
    ],
    technologies: ["Pharma", "GMP", "Electrical Design", "Redundancy"],
    image: "/ref-sweco.png"
  }
];

export const whyUs = [
  {
    title: "Leveringssikkerhed",
    description: "Vi driver fremdrift og lukker åbne ender -- med klar ansvarlighed og risikostyring.",
    icon: "ShieldCheck"
  },
  {
    title: "Teknisk tyngde",
    description: "Fra LV‑design og selektivitet til dokumentations- og standardkrav (DS/EN, IEC).",
    icon: "Compass"
  },
  {
    title: "Sikkerhed & kvalitet",
    description: "HSEQ i praksis: audits, toolbox, afvigelser og løbende forbedringer.",
    icon: "Shield"
  }
];

export const workflow = [
  { step: "1", title: "Afklaring", description: "Mål, scope, interfaces og krav." },
  { step: "2", title: "Plan", description: "Tidsplan, budget, risiko og bemanding." },
  { step: "3", title: "Eksekvering", description: "Koordinering, kvalitet, dokumentation." },
  { step: "4", title: "Overlevering", description: "FAT/SAT, O&M/As‑Built, lessons learned." }
];
